import React from "react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Table
} from "reactstrap";
import swal from 'sweetalert';

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import axios from "axios";
import {base_api_url} from "variables/general.js";
import $ from "jquery";
import datepickerFactory from 'jquery-datepicker';

function getData() {

  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

  let urlTarget = base_api_url + '/api/v1/nc/getnotebyid?notesId=' + params.id; 
  return axios.get(urlTarget).then(res => {
    let data = res.data.response;
    $("#s_reason").val(data.reason);
    $("#s_notes").val(data.notes);
    $("#s_name").val(data.receiversname);
    $("#br_name").html(data.receiversname);
  })
}

function submitData() {

  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

  var date = new Date();
  var timestamp = date.toISOString();

  let user_login = JSON.parse(localStorage.getItem('user_login'));
  var curr_user_id = user_login.reference_id;

  //let test = JSON.parse(localStorage.getItem("detailLogs"+params.id));

  const requestData = {
    submittersfkuserid: curr_user_id,
    submittersfkuserrole: "coord",
    notes: $("#s_notes").val(),
    //fkstudentid: params.id,
    id: params.id,
    studentname: $("#s_name").val(),
    receiversname: $("#s_name").val(),
    notescreen: "coordStudentLogs",
    reason: $("#s_reason").val(),
    timestamp: timestamp
  };


  //console.log('> 3');
  //console.log( requestData );
  //console.log( test)
  return axios.put(base_api_url + "/api/v1/nc/updatebynotesid", requestData).then(res => {
    swal("Success","Successfully update data!","success");
    setTimeout(function(){
      window.location.reload();
    },500);
  }).catch(function (error) {
    swal("Failed!", "Something went wrong!", "error");
  });


}


class GardaVettingDetail extends React.Component {
  componentDidMount(){

    datepickerFactory($);
    $(document).on("click",".btn-csconfirm",function(e){
      e.preventDefault();

      $(".errorCs").remove();
      
      let notValid = 0;
      let msgval = "";
      let cv;

      $.each($('form input'), function(index, formField) {
        if ($(formField).val()==="") {
          cv = $(formField).parent().find("label").text();
          if (cv!=="") {
            msgval = cv + " is required! <br/>";
            $(formField).parent().append("<span class='errorCs'>" + msgval + "</span>");
            notValid += 1;
          }
        }
      });

      if (notValid>0) {
        //$("#msgValidation").show();
      } else {
        submitData();
      }
      
    });

    $(document).on("click",".close",function(){
      $(this).parent().parent().hide();
    });

    getData()

  }

  render() {
    return (
      <>
        <PanelHeader size="sm"
          content={
            <div className="content">
              <div className="header text-left">
                <span className="panelHeaderDesc">View and manage Student logs.</span>
                <nav aria-label="breadcrumb" role="navigation">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="/coordinator/overview">Dashboard</a></li>
                    <li class="breadcrumb-item"><a href="/coordinator/report/standard-report">Standard Reports</a></li>
                    <li class="breadcrumb-item"><a href="/coordinator/report/standard-report/student-logs">Student Logs</a></li>
                    <li class="breadcrumb-item active" aria-current="page" id="br_name"></li>
                  </ol>
                </nav>
              </div>
            </div>
          }
        />
        <br/>
        <div className="content">
          <Form name="formsubmit" id="formsubmit" action="/" className="form-horizontal" method="post">
            <Row>
              <Col md="3">
                <Card className="card-chart">
                  <CardBody>
                    <Table responsive>
                      <tbody>
                        <tr>
                          <td className="td-noborder">
                            <a href="#c_h_n" className="anchorItemDetail">Student Logs</a>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </CardBody>
                </Card>
              </Col>
              <Col md="9">
                <Card id="c_h_n">
                  <CardHeader>
                    <CardTitle tag="h4" className="panelTitle">Student Logs</CardTitle>
                  </CardHeader>
                  <CardBody>
                    <Row>
                      <Col sm="12">
                        <FormGroup>
                          <h4 className="subHeaderBlue">Student Logs</h4>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="12">
                        <Row>
                          <Col md="6">
                            <FormGroup>
                              <div class="form-floating">
                                <Input id="s_name" style={{"borderRadius": "5px"}} placeholder="ID" type="text" />
                                <label for="pwd">Student Name</label>
                              </div>
                            </FormGroup>
                          </Col>
                          <Col md="6">
                            <FormGroup>
                              <div class="form-floating">
                                <Input id="s_reason" style={{"borderRadius": "5px"}} placeholder="ID" type="text" />
                                <label for="pwd">Reason</label>
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="12">
                        <Row>
                          <Col md={12}>
                            <FormGroup>
                              <div class="form-floating">
                                <textarea className="form-control" id="s_notes" style={{borderRadius: "5px",border: "1px solid #e3e3e3"}} placeholder="ID" type="text" />
                                <label for="pwd">Notes</label>
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                <Row>
                  <Col sm="12">
                    <div className="pull-right">
                      <button className="btn-csconfirm">Update Changes</button>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </div>
      </>
    );
  }
}

export default GardaVettingDetail;
